import {  useLocation } from "react-router-dom";
import { useLayoutEffect} from "react";
import Header from "./Header";
import Footer from "./Footer";
import parser from "html-react-parser";
import "../styles/App.css";

const GuruDetailPage = () => {
  const currentLanguageVal = localStorage.getItem("language");
  const currentLanguage = currentLanguageVal ? currentLanguageVal : "en";

  const location = useLocation();
  const { description, image, name, name_hindi } = location.state || {};

  useLayoutEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [location.pathname]);

  return (
    <>
      <Header />
      <div className="guru-detail-page">
        <div className="guru-detail-photo">
          <img
            className="guru-detail-image"
            src={`data:image/jpg;base64,${image}`}
            height="200px"
            width="auto"
            alt="Swami ji"
          />
          <div className="guru-detail-name">{currentLanguage === "en" ? name : name_hindi}</div>
        </div>

        <div className="guru-detail-body">
          {description &&
            description.length > 0 &&
            description.map((item) => {
              return (
                <>
                  <h3>{currentLanguage === "en" ? item.section : item["section-hindi"]}</h3>
                  {currentLanguage === "en" ?  item.paragraphs.map((elem) => (
                    <p>{parser(elem)}</p>
                  )):item["paragraphs-hindi"].map((elem) => (
                    <p>{parser(elem)}</p>
                  )) }
                </>
              );
            })}
        </div>
      </div>
      <Footer />
    </>
  );
};
export default GuruDetailPage;
